
import CheckboxGroup from './checkbox-group'

export default CheckboxGroup



// WEBPACK FOOTER //
// ./src/components/checkbox-group/index.js